module.exports = __webpack_public_path__ + "img/2f6cc2d.jpg";